import CardIcon from "/static/images/landing/icons/card.svg"
import CreditIcon from "/static/images/landing/icons/credit.svg"
import LimitIcon from "/static/images/landing/icons/limit.svg"
import LoansIcon from "/static/images/landing/icons/loans.svg"
import RecoveryIcon from "/static/images/landing/icons/recovery.svg"
import tracking from "../../../../trackings"

import "./Card.scss"

const iconList = {
  "Cartões de Crédito": <CardIcon width={40} heigth={32} />,
  "Crédito Pessoal": <CreditIcon width={40} heigth={26} />,
  "Empréstimo Consignado": <LoansIcon width={39} heigth={48} />,
  "Limite da Conta": <LimitIcon width={29} heigth={40} />,
  "Dívidas Recovery": <RecoveryIcon width={40} heigth={40} />,
}

const Card = ({ content }) => {
  const Icon = iconList[content]
  const onCardClick = () => {
    tracking.cardsClick()

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  return (
    <div className="landing-card" role="button" onClick={onCardClick}>
      {Icon}
      <p className="landing-card__title">{content}</p>
    </div>
  )
}

export default Card
